/**
 * @generated SignedSource<<a49b54a5f86239f2bc29dbcf87f671bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityLessonBookingDays_facility$data = {
  readonly club: {
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly privateLessonsPermissionSet: {
    readonly bookingWindowDays: number | null | undefined;
  } | null | undefined;
  readonly publicLessonsPermissionSet: {
    readonly bookingWindowDays: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityLessonBookingDays_facility";
};
export type useFacilityLessonBookingDays_facility$key = {
  readonly " $data"?: useFacilityLessonBookingDays_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonBookingDays_facility">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bookingWindowDays",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityLessonBookingDays_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PrivateLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "privateLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "publicLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "968cdcfd6d66bfb6749d4791b624cd51";

export default node;
